var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcHomeMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 9.20157C3 8.77233 3 8.55771 3.05758 8.36007C3.10858 8.18499 3.1924 8.02032 3.30491 7.87415C3.43193 7.70914 3.60824 7.57737 3.96086 7.31385L9.23599 3.37154C9.50924 3.16733 9.64586 3.06522 9.79673 3.02597C9.92985 2.99134 10.0702 2.99134 10.2033 3.02597C10.3541 3.06522 10.4908 3.16733 10.764 3.37154L16.0391 7.31385C16.3918 7.57737 16.5681 7.70914 16.6951 7.87415C16.8076 8.02032 16.8914 8.18499 16.9424 8.36007C17 8.55771 17 8.77233 17 9.20157V14.6085C17 15.4456 17 15.8642 16.8305 16.1839C16.6813 16.4651 16.4433 16.6938 16.1507 16.8371C15.8179 17 15.3823 17 14.5111 17H5.48889C4.6177 17 4.1821 17 3.84935 16.8371C3.55665 16.6938 3.31868 16.4651 3.16955 16.1839C3 15.8642 3 15.4456 3 14.6085V9.20157Z",
    fill: "#1B92FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 14L13 14",
    stroke: "#E9F4FF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHomeMedium);
export default __webpack_public_path__ + "static/media/ic_home_medium.7df2a9915ca5a656863ef8e20e736b1d.svg";
export { ForwardRef as ReactComponent };